import { useContext } from "react";
import FactoryContext from "../../contexts/factoryContext";
import useQueryMessageBoard from "../queries/useQueryMessageBoard";

/**
 *
 * @returns {{messages: ?MessageCollection, messageBoardQuery: UseQueryResult<*, unknown>}}
 */
export default function useMessageBoard(pageNum, limit) {
  const factory = useContext(FactoryContext);
  const messageBoardQuery = useQueryMessageBoard(pageNum, limit);

  let messages = null;
  if (messageBoardQuery?.data?.messages) {
    messages = factory.makeMessageCollection(
      messageBoardQuery.data.messages,
      messageBoardQuery.data.replies
    );
  }

  return { messages, messageBoardQuery };
}
